import { NivelEnsinoEnumType } from '../types/enums/NivelEnsinoEnumType';

const NivelEnsinoEnum: { [key: string]: any } = Object.freeze({
  BASICO: {
    descricao: 'label.basico',
    key: 'B',
  },
  DOUTORADO: {
    descricao: 'label.doutorado',
    key: 'D',
  },
  FORMACAO_COMPLEMENTAR: {
    descricao: 'label.formacao_complementar',
    key: 'F',
  },
  FUNDAMENTAL: {
    descricao: 'label.fundamental',
    key: 'U',
  },
  GRADUACAO: {
    descricao: 'label.graduacao',
    key: 'G',
  },
  INFANTIL: {
    descricao: 'label.infantil',
    key: 'I',
  },
  INTEGRADO: {
    descricao: 'label.integrado',
    key: 'N',
  },
  LATO: {
    descricao: 'label.lato_sensu',
    key: 'L',
  },
  MEDIO: {
    descricao: 'label.medio',
    key: 'M',
  },
  MESTRADO: {
    descricao: 'label.mestrado',
    key: 'E',
  },
  RESIDENCIA: {
    descricao: 'label.residencia',
    key: 'R',
  },
  STRICTO: {
    descricao: 'label.stricto_sensu',
    key: 'S',
  },
  TECNICO: {
    descricao: 'label.tecnico',
    key: 'T',
  },
  findByKey: (key: string) => {
    let objFound = NivelEnsinoEnum.getAll().find((obj: NivelEnsinoEnumType) => obj.key === key);
    if (objFound) {
      return objFound;
    }
    throw Error(`Chave ${key} não foi encontrada na enum.`);
  },
  getAll: () =>
    Object.keys(NivelEnsinoEnum)
      .filter((genericProperty) => typeof NivelEnsinoEnum[genericProperty] === 'object')
      .map((indexFound) => NivelEnsinoEnum[indexFound]),
});

export default NivelEnsinoEnum;
